namespace advisorop.components.advisor {

    export class InvDmsListController {
        // bindings
        accountId: number;
        documentType: number;
        documentTypes: domains.ILOV[] = [];
        selDocumentType: domains.ILOV;
        documents: any[];
        dgDocumentsOptions: DevExpress.ui.dxDataGridOptions;

        // properies for file upload
        uploadEnabled: boolean = true;
        uploadFiles = [];

        uploadUrl: string;
        uploadFileOptions: DevExpress.ui.dxFileUploaderOptions;
        // uploadDisabled: true;

        showDisabled: boolean = false;
        includeHistory: boolean = false;


        static $inject = ["investorService", "generalService"];
        constructor(
            private invSrv: services.InvestorService,
            private generalService: services.GeneralService
        ) {
            this.dgDocumentsOptions = {
                //export: {
                //    enabled: true,
                //    fileName: "Documents"
                //},
                bindingOptions: {
                    dataSource: "vm.documents"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 25 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                noDataText: "No Documents",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "documentTypeDesc", caption: "Document Type", width: 150 },
                    { dataField: "dateCreated", caption: "Date Created", dataType: "date", width: 120 },
                    { dataField: "version", caption: "Ver.", width: 40 },
                    { dataField: "extension", caption: "Ext.", width: 40 },
                    { dataField: 'enableDisableStatus', caption: 'File Status', width: 70 },
                    { dataField: "id", caption: "#", cellTemplate: "colActions", width: 140 }
                ],
                masterDetail: {
                    enabled: true,
                    template: "versions",
                    autoExpandAll: false
                },
            };
        }
        
        // loading methods

        loadDocuments(): void {
            //console.log("Loading documents .... Account:", this.accountId, " Document Type:", this.documentType);
            if (this.accountId > 0) {
                this.invSrv.getAccountDocumentation(this.accountId, this.documentType, this.includeHistory, this.showDisabled)
                    .then(response => this.documents = response.data, err => this.generalService.showError(err));
            } else {
                this.invSrv.getInvestorDocumentation(this.documentType, this.includeHistory, this.showDisabled)
                    .then(response => this.documents = response.data, err => this.generalService.showError(err));
            }
            //console.log("Documents:", this.documents);
        }

        //loadDocumentTypes(): void {
        //    console.log("Loading document types .... Account:", this.accountId, " Investor:", this.investor);
        //    if (this.accountId > 0) {
        //        this.generalService.getLOVs()
        //            .then(data => this.documentTypes = data.filter(f => f.lovType == domains.LovType.DOCUMENT_TYPE && f.extra3 == "1"));
        //    } else if (this.investor && this.investor.id > 0) {
        //        if (this.investor.investorType == domains.InvestorType.INDIVIDUAL) {
        //            this.generalService.getLOVs()
        //                .then(data => this.documentTypes = data.filter(f => f.lovType == domains.LovType.DOCUMENT_TYPE && f.extra3 == "3"));
        //        } else if (this.investor.investorType == domains.InvestorType.COMPANY) {
        //            this.generalService.getLOVs()
        //                .then(data => this.documentTypes = data.filter(f => f.lovType == domains.LovType.DOCUMENT_TYPE && f.extra3 == "2"));
        //        }
        //    }
        //}

        // overrides
        $onChanges(evt): void {
            for (var key in evt) {
                // this.loadDocumentTypes();
                this.loadDocuments();
            }
        }

        $onInit(): void {
        }
    }

    class InvDmsList implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                accountId: "<",
                documentType: "<",
            };
            this.controller = InvDmsListController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/investor-module/components/inv-dms-list.html";
        }

    }
    angular.module(Constants.APP).component("invDmsList", new InvDmsList());
}